import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga4";
import ReactGA1 from "react-ga";
import { isProduction, isStagingEnv } from "../../lib/utils";
import { connect } from "react-redux";

const ReactGaContainer = (props) => {
    useEffect(() => {
        // if (isProduction()) ReactGA.initialize("UA-202707856-2", { debug: false });
        if (isProduction()) {
            ReactGA.initialize(
                [
                    {
                        trackingId: "G-S43ED8J3EH",
                    },
                    // {
                    //     trackingId: "UA-202707856-2",
                    // },
                ],
                //    , { debug: false }
            );
            ReactGA.set({ page: "radarr" });

            ReactGA1.initialize(
                [
                    {
                        trackingId: "UA-202707856-2",
                    },
                ],
                //    , { debug: false }
            );
            ReactGA1.set({ page: "radarr v3" });
        }
        //  else if (isStagingEnv()) {
        //     ReactGA.initialize(
        //         [
        //             {
        //                 trackingId: "G-S43ED8J3EH",
        //                 testMode: true,
        //             },
        //             // {
        //             //     trackingId: "UA-202707856-2",
        //             // },
        //         ],
        //         //    , { debug: false }
        //     );
        //     ReactGA.set({ page: "Radarr dev-env" });

        //     ReactGA1.initialize(
        //         [
        //             {
        //                 trackingId: "UA-202707856-2",
        //             },
        //         ],
        //         //    , { debug: false }
        //     );
        //     ReactGA1.set({ page: "radarr v3 dev-env" });
        // }
    }, []);

    useEffect(() => {
        // console.log(props.location)
        setTimeout(() => {
            ReactGA1.pageview(window.location.pathname + window.location.search, [], document.title);
        }, 100);
        setTimeout(() => {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
            // ReactGA.pageview(window.location.pathname + window.location.search, [], document.title);
        }, 100);
    }, [props.location?.pathname]);

    useEffect(() => {
        // console.log("users-->", props.user);
        if (props.user) {
            ReactGA.set({
                userId: props.company.company_identifier + "_" + props.user.email.split("@")[0] + "_" + props.packageObj.package_code,
            });
            ReactGA.set({ dimension1: props.packageObj.package_code });
            ReactGA.set({ dimension2: props.user.id });
            ReactGA.set({ dimension3: props.company.company_identifier });
            ReactGA.set({ dimension4: props.user.email?.split("@")[0] });
            // older version GA 3
            ReactGA1.set({
                userId: props.company.company_identifier + "_" + props.user.email.split("@")[0] + "_" + props.packageObj.package_code,
            });
            ReactGA1.set({ dimension1: props.packageObj.package_code });
            ReactGA1.set({ dimension2: props.user.id });
            ReactGA1.set({ dimension3: props.company.company_identifier });
            ReactGA1.set({ dimension4: props.user.email?.split("@")[0] });
        } else {
            ReactGA.set({ userId: null });
            ReactGA.set({ dimension1: null });
            ReactGA.set({ dimension2: null });
            ReactGA.set({ dimension3: null });
            ReactGA.set({ dimension4: null });

            // support older version GA 3
            ReactGA1.set({ userId: null });
            ReactGA1.set({ dimension1: null });
            ReactGA1.set({ dimension2: null });
            ReactGA1.set({ dimension3: null });
            ReactGA1.set({ dimension4: null });
        }
    }, [props.user]);

    return null;
};

const mapStateToProps = (state) => ({
    company: state.globalReducer.company,
    packageObj: state.globalReducer.packageObj,
    user: state.globalReducer.user,
});

export default connect(mapStateToProps)(withRouter(ReactGaContainer));
